import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterLocation',
  standalone: false,
})
export class FilterLocationPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!args) return value;
    return value.filter((location) => {
      return args.indexOf(location.location) !== -1;
    });
  }
}
